var map = {
	"./angbao-bonus-thaipusam.webp": 2499,
	"./angbao-bonus.webp": 2500,
	"./angbao-bonus_dewali.webp": 2501,
	"./cny-lucky-draw.webp": 2502,
	"./cny-promo.webp": 2503,
	"./dewali-promo.webp": 2504,
	"./fifa-logo.webp": 2505,
	"./fifa-prediction.webp": 2506,
	"./fifa-qna.webp": 2507,
	"./raya-promo.webp": 2508,
	"./welcome-cny-bonus.webp": 2509
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2498;